import { render, staticRenderFns } from "./BolPage.vue?vue&type=template&id=606dd292&scoped=true"
import script from "./BolPage.vue?vue&type=script&lang=js"
export * from "./BolPage.vue?vue&type=script&lang=js"
import style0 from "./BolPage.vue?vue&type=style&index=0&id=606dd292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606dd292",
  null
  
)

export default component.exports